"use strict";

var _require = require("./annotationTypes"),
    modifiableTypes = _require.modifiableTypes;

var adjustAnnotationsToInsert = require("./adjustAnnotationsToInsert");

module.exports = function shiftAnnotationsByLen(_ref) {
  var seqData = _ref.seqData,
      caretPosition = _ref.caretPosition,
      insertLength = _ref.insertLength;

  modifiableTypes.forEach(function (annotationType) {
    var existingAnnotations = seqData[annotationType];
    seqData[annotationType] = adjustAnnotationsToInsert(existingAnnotations, caretPosition, insertLength);
  });
};